import React, { useEffect, useState } from "react";
import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import labels from "../../constants/Label";
import configuration from "../../config";
import { toast } from "react-toastify";
import UND from "underscore";
import commonConstant from "../../constants/Common";
import Loader from "../../components/Loader/Loader";

// For Edit Label
let Id = "";
function Edit({ history }) {
  const [fieldArr, setFieldArr] = useState([]);
  const [fields, setFields] = useState({});
  const [languages, setLanguages] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoader, setIsLoader] = useState(false);

  // const userTypesOpt = [
  //   { id: 0, value: "customer", label: "Customer" },
  //   { id: 2, value: "delivery_boy", label: "Delivery Boy" },
  // ];

  const columnArr = [
    { id: 0, title: "Title", name: "title", type: "TextInput" },
    {
      id: 1,
      title: "Code",
      name: "label_code",
      type: "TextInput",
      is_read_only: true,
    },
    {
      id: 2,
      title: "User Type",
      name: "user_type",
      type: "MultiDropdown",
      options: commonConstant.user_type,
    },
  ];

  useEffect(() => {
    setIsLoader(true);
    var url = window.location.href;
    Id = url.substring(url.lastIndexOf("/") + 1);
    configuration
      .getAPI({ url: "language-label/list", params: { label_id: Id } })
      .then((data) => {
        if (data.status === 200) {
          setFields(data.payload);
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
    getlanguages();
  }, []);

  function getlanguages() {
    setIsLoader(true);
    configuration
      .getAPI({ url: "language/list", params: {} })
      .then((data) => {
        if (data.status === 200) {
          setLanguages(data.payload);
          let value_arr = [];
          UND.each(data.payload, (lang, ind) => {
            value_arr.push({
              id: ind,
              title: "Value[" + lang.title + "]",
              name: "value_" + lang.code,
              type: "TextInput",
            });
          });
          const fullCoulnmArr = columnArr.concat(value_arr);
          setFieldArr(fullCoulnmArr);
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  // function handleChange(field, e) {
  //   setFields({ ...fields, [field]: e.target.value })
  // }

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.user_type) {
      error["user_type"] = "Please select user type";
      flag = false;
    }
    if (!fields.title) {
      error["title"] = "Please enter label title";
      flag = false;
    }
    if (!fields.label_code) {
      error["label_code"] = "Please enter code";
      flag = false;
    }
    UND.each(languages, (lang, ind) => {
      if (!fields["value_" + lang.code]) {
        error["value_" + lang.code] = "Please enter value in " + lang.title;
        flag = false;
      }
    });
    setErrors({ ...error });
    return flag;
  }

  function handleChange(field, e) {
    if (field == "user_type") {
      setFields({ ...fields, user_type: e });
    } else {
      setFields({ ...fields, [field]: e.target.value });
    }
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      configuration
        .postAPI({ url: "language-label/update", params: fields })
        .then((data) => {
          if (data.status === 200) {
            toast.success("Record updated successfully");
            history.push("/label");
          } else if (data.error) {
            setIsLoader(false);
            return toast.error(data.error.message);
          } else {
            setIsLoader(false);
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.editLabel} />
      <AddEditSection
        title="Edit Label"
        path="/label"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Edit;
